import React from "react";

/**
 * @component DollarClockIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <DollarClockIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarClockIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DollarClockIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M20 13v1h2v2h-4v1h3a1 1 0 01.993.883L22 18v3a1 1 0 01-.883.993L21 22h-1v1h-2v-1h-2v-2h4v-1h-3a1 1 0 01-.993-.883L16 18v-3a1 1 0 01.883-.993L17 14h1v-1h2zM18 2v6l-4 4 1.199 1.199L14.2 14.7 12 12.5l-4 4V20h6v2H6v-6l4-4-4-4V2h12zm-2 2H8v3.5l4 4 4-4V4z"
        fillRule="evenodd"
      />
    </svg>
  )
);
DollarClockIcon.displayName = "DollarClockIcon";
export default DollarClockIcon;
